import { render, staticRenderFns } from "./VFieldDate.vue?vue&type=template&id=2e34e694&"
import script from "./VFieldDate.vue?vue&type=script&lang=js&"
export * from "./VFieldDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e34e694')) {
      api.createRecord('2e34e694', component.options)
    } else {
      api.reload('2e34e694', component.options)
    }
    module.hot.accept("./VFieldDate.vue?vue&type=template&id=2e34e694&", function () {
      api.rerender('2e34e694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldDate.vue"
export default component.exports